// extracted by mini-css-extract-plugin
export default {"Circle3":"Circle3_Circle3__v5Wz0"};